import DevBuildBanner from "./DevBuildBanner";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Controller, { HostController } from "./pages/controller";
import Dashboard, { JoinLanding } from "./pages/dashboard";
import HostDashboard from "./pages/host-dashboard";
import ExternalRedirect from "./components/external-redirect";
import { LEGACY_PRIVACY_PATH, PRIVACY_POLICY_URL } from "./config/legal";
import EnablePreview from "./pages/enable-preview";
import AuthCallback from "./pages/auth-callback";
import Upgrade from "./pages/upgrade";
import UpgradeSuccess from "./pages/upgrade-success";
import Audience from "./pages/audience";

function App() {
  return (
    <BrowserRouter>
      <DevBuildBanner />
      <Routes>
        {/* A signed-in host's dashboard; the join page for everyone else. */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/join" element={<JoinLanding />} />
        <Route path="/history" element={<HostDashboard section="history" />} />
        <Route path="/presentations" element={<Navigate to="/history" replace />} />
        <Route path="/billing" element={<HostDashboard section="billing" />} />
        <Route path="/profile" element={<HostDashboard section="profile" />} />
        <Route path="/presentation/:magicId" element={<Controller />} />
        <Route path="/host/deck/:presentationId" element={<HostController />} />
        {/* The audience's way in. Short path because it is read off a projected
            screen and typed by hand — copresent.app/q/K3M9QP redirects here.
            No account, no invite token: the code IS the capability. */}
        <Route path="/q/:code" element={<Audience />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/enable-preview" element={<EnablePreview />} />
        <Route path="/upgrade" element={<Upgrade />} />
        {/* The history page moved into the dashboard. */}
        <Route path="/account" element={<Navigate to="/history" replace />} />
        <Route path="/upgrade/success" element={<UpgradeSuccess />} />
        {/* The policy lives on the website now; old links still land here. */}
        <Route path={LEGACY_PRIVACY_PATH} element={<ExternalRedirect to={PRIVACY_POLICY_URL} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
